import React, { useRef } from "react"

type Props = {
  value: string | string[]
  onChange: (value: string | string[]) => void
  variableNames: string[]
  asArray?: boolean
  rows?: number
  placeholder?: string
}

const VariableTextInput: React.FC<Props> = ({
  value,
  onChange,
  variableNames,
  asArray = false,
  rows = 3,
  placeholder,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const stringValue = Array.isArray(value) ? value.join("\n\n") : value

  const insertVariable = (name: string) => {
    const ta = textareaRef.current
    if (!ta) return
    const before = stringValue.slice(0, ta.selectionStart ?? stringValue.length)
    const after = stringValue.slice(ta.selectionEnd ?? stringValue.length)
    const insertion = `{{${name}}}`
    const next = before + insertion + after
    if (asArray) {
      onChange(next.split(/\n{2,}/))
    } else {
      onChange(next)
    }
    requestAnimationFrame(() => {
      ta.focus()
      const cursor = before.length + insertion.length
      ta.setSelectionRange(cursor, cursor)
    })
  }

  return (
    <div>
      <textarea
        ref={textareaRef}
        rows={rows}
        value={stringValue}
        placeholder={placeholder}
        onChange={(e) => {
          if (asArray) {
            onChange(e.target.value.split(/\n{2,}/))
          } else {
            onChange(e.target.value)
          }
        }}
        className="w-full border rounded px-2 py-1 text-sm font-mono"
      />
      {variableNames.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-1">
          <span className="text-xs text-gray-500">Insert variable:</span>
          {variableNames.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => insertVariable(n)}
              className="text-xs px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded font-mono">
              {`{{${n}}}`}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default VariableTextInput
